import {h, Fragment} from "preact"
import { useAppStateSelector, pick } from "@nosto/preact"
import Sidebar from "./Sidebar"

/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
function ContentWrapper({ type, children }) {
    const {
        foundProducts,
        products,
        loading
    } = useAppStateSelector(state => ({ 
        foundProducts: state.response.products?.total > 0, 
        products: state.response.products,
        loading: state.loading }))

    const { pageType, query } = useAppStateSelector(state => pick(state, "pageType", "query") )

    return (
        <div class="ns-serp"
            data-nosto-element={type}>
            {foundProducts && <Sidebar />}
            <div
                class="productgrid--wrapper"
                style={{ position: loading ? "relative" : "initial" }}>
                <nav class="breadcrumbs-container" aria-label="Breadcrumbs">
                    <a href="/">Home</a>
                    <span class="breadcrumbs-delimiter" aria-hidden="true">
                        <svg class="icon-chevron-down-thin " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none"><title>Chevron down icon</title><path d="M0.5 0.5L4 4L7.5 0.5" stroke="currentColor" stroke-width="1.25"></path></svg>
                    </span>
                    <span>{pageType == "search" ? 'Search Results' : `${products?.categoryPath}`}</span>
                </nav>
                <div class="productgrid--masthead">
                    <div class="collection--information">
                        {foundProducts && 
                            pageType == "search" ? (<h1 class="collection--title ns-text-align-center">Search results for "{query?.query}"</h1>)
                            : (<h1 class="collection--title">{products?.categoryPath}</h1>)
                        }
                    </div>
                </div>

                { children({ loading, foundProducts }) }
            </div>
        </div>
    )
}

export function wrapContent(type, Component) {
    return () => (<ContentWrapper type={type}>{Component}</ContentWrapper>)
}

